import { EventMeta } from '../../../interfaces/meta.interface';

const mailItemsAccessed: EventMeta = {
    title: 'Mail Items Accessed',
    default: {
        description: 'Mail Items Accessed',
        longDescription: 'Messages were read or accessed in the mailbox.',
        severity: 'info',
    },
    classifications: [
        // Mailbox access from outside every configured allow-list, by a member of the organisation.
        // This is the payload step of token theft — once an attacker holds a stolen token, reading
        // the mailbox is what they came for — and it is the one post-compromise operation that
        // reliably carries a usable ClientIP, so the geo predicates can actually decide on it.
        //
        // Graded `warning` to match SharePoint/OneDrive `FileAccessed`, the established precedent
        // for a high-volume access operation: mailbox access is bursty, so one compromised session
        // produces many events, and this keeps the grade consistent across analogous operations.
        // Anything else — a non-org account, Microsoft's own service ranges, or an allow-listed
        // location — falls through to the `info` default.
        {
            severity: 'warning',
            description: `An unapproved IP outside your allowed ASN, IPs, region, or country accessed a mailbox`,
            longDescription:
                'Messages were read or accessed in a mailbox from an IP outside all of your allowed ASNs, IPs, regions, and countries. Mailbox access from an unapproved location is the step that follows a stolen token, and is how business email compromise is usually first seen. Review the access and, if it was not expected, revoke the account\'s sessions and check for inbox rules or forwarding added around the same time.',
            predicates: {
                isAllowedASN: false,
                isAllowedIP: false,
                isAllowedRegion: false,
                isAllowedCountry: false,
                isMicrosoftActivity: false,
                isUserMemberOfOrganisation: true,
            },
        },
    ],
};

export default mailItemsAccessed;
